// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonthlyTripCards_month-container__7S26G{
    margin-top: 4vw;
    min-height: 12vw;
}

.MonthlyTripCards_month-name__i3IA0{
    font-size: 4vw;
    text-align: center;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0;
}

.MonthlyTripCards_underline__PqSik{
    color: rgb(230, 84, 57);
    font-size: 3vw;
    text-align: center;
    margin-top: -2.5vw;
    margin-bottom: 0px;
    font-family: sans-serif;
}

.MonthlyTripCards_month-dropdown-adjust__1zgIp{
    position: relative;
    z-index: 1;
    margin-top: -4.5vw;
    margin-left: 70vw;
    margin-right: 5vw;
}

.MonthlyTripCards_mobile-filter-month__k6dU9{
    display: none;
}

@media(max-width: 768px){
    .MonthlyTripCards_month-container__7S26G{
        margin-bottom: 7vw;
    }
    
    .MonthlyTripCards_month-name__i3IA0{
        font-size: 10vw;
        text-align: center;
        font-weight: 500;
        margin-bottom: 0;
        margin-top: 0;
    }
    
    .MonthlyTripCards_underline__PqSik{
        color: rgb(230, 84, 57);
        font-size: 10vw;
        text-align: center;
        margin-top: -9vw;
        margin-bottom: 0px;
        font-family: serif;
    }

    .MonthlyTripCards_month-dropdown-adjust__1zgIp{
        display: none;
    }

    .MonthlyTripCards_mobile-filter-month__k6dU9{
        display: flex;
        position: relative;
        height: 20vw;
        margin-top: 5vw;
        z-index: 1;
        /* margin-bottom: 10vw; */
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ExploreTrips/MonthlyTripCards/MonthlyTripCards.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,UAAU;QACV,yBAAyB;IAC7B;AACJ","sourcesContent":[".month-container{\n    margin-top: 4vw;\n    min-height: 12vw;\n}\n\n.month-name{\n    font-size: 4vw;\n    text-align: center;\n    font-weight: 500;\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n.underline{\n    color: rgb(230, 84, 57);\n    font-size: 3vw;\n    text-align: center;\n    margin-top: -2.5vw;\n    margin-bottom: 0px;\n    font-family: sans-serif;\n}\n\n.month-dropdown-adjust{\n    position: relative;\n    z-index: 1;\n    margin-top: -4.5vw;\n    margin-left: 70vw;\n    margin-right: 5vw;\n}\n\n.mobile-filter-month{\n    display: none;\n}\n\n@media(max-width: 768px){\n    .month-container{\n        margin-bottom: 7vw;\n    }\n    \n    .month-name{\n        font-size: 10vw;\n        text-align: center;\n        font-weight: 500;\n        margin-bottom: 0;\n        margin-top: 0;\n    }\n    \n    .underline{\n        color: rgb(230, 84, 57);\n        font-size: 10vw;\n        text-align: center;\n        margin-top: -9vw;\n        margin-bottom: 0px;\n        font-family: serif;\n    }\n\n    .month-dropdown-adjust{\n        display: none;\n    }\n\n    .mobile-filter-month{\n        display: flex;\n        position: relative;\n        height: 20vw;\n        margin-top: 5vw;\n        z-index: 1;\n        /* margin-bottom: 10vw; */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"month-container": `MonthlyTripCards_month-container__7S26G`,
	"month-name": `MonthlyTripCards_month-name__i3IA0`,
	"underline": `MonthlyTripCards_underline__PqSik`,
	"month-dropdown-adjust": `MonthlyTripCards_month-dropdown-adjust__1zgIp`,
	"mobile-filter-month": `MonthlyTripCards_mobile-filter-month__k6dU9`
};
export default ___CSS_LOADER_EXPORT___;
